<script>
import { defineComponent } from "vue";
import awaitingReceiptItem from "@/components/consignment/awaitingReceipt/awaitingReceiptItem.vue";
import receiveConsignmentFooter from "@/components/consignment/awaitingReceipt/receiveConsignmentFooter.vue";
import { useMeta } from 'quasar';

const metaData = {
  // sets document title
  title: 'Consignment: Awaiting Receipt',
  // optional; sets final title as "Index Page - My Website", useful for multiple level meta
  titleTemplate: title => `${title}`,
}

export default defineComponent({
  name: "consignmentAwaitingReceipt",
  setup() {
    useMeta(metaData);
  },
  data() {
    return {};
  },
  components: {
    awaitingReceiptItem,
    receiveConsignmentFooter
  },
  computed: {
    showLoading() {
      return this.$store.getters["consignment/onHandLoading"];
    },
    accessToken() {
      return this.$store.getters["auth/accessToken"];
    },
    orders() {
      return this.$store.getters["consignment/awaitingReceipt"];
    },
    items() {
      let items = [];

      try {
        this.orders.forEach((i, orderIndex) => {
          i.lines.forEach((y, lineIndex) => {
            items.push({
              itemNumber: y.itemNumber,
              description: y.description,
              qty: y.quantity,
              uom: y.quantityUnitOfMeasure,
              orderNumber: i.orderNumber,
              po: i.purchaseOrderNumber,
              invoiceNumber: i.invoiceNumber,
              ticketNumber: i.ticketNumber,
              status: i.status,
              tracking: i.tracking,
              orderIndex: orderIndex,
              lineIndex: lineIndex,
            });
          });
        });
      } catch (e) {}

      return items;
    },
    selectedReceive() {
        return this.$store.getters['consignment/selectedReceive']
    },
    consignmentPermission() {
      return this.$store.getters["auth/consignmentPermission"];
    }
  },
  mounted() {
    if (this.consignmentPermission == "0") {
        this.$router.push('/');
    }
    this.$store.dispatch("consignment/getConsignmentOrders", this.accessToken);
  },
});
</script>

<template>
  <div>
    <div class="mobileDiv"></div>
    <div v-if="orders.length > 0 && !showLoading">
      <q-scroll-area ref="scrollTargetRef" v-bind:style="{height: '100vh',maxWidth: '100%',paddingBottom: '50px',}">
        <q-list bordered>
          <awaiting-receipt-item
            v-for="(item, idx) in items"
            :key="idx"
            :item="item"
          ></awaiting-receipt-item>
        </q-list>
      </q-scroll-area>
    </div>
    <div v-if="orders.length == 0 && !showLoading">
      <h6 class="wcwH text-center text-grey-7 q-pt-md">
        No Material Awaiting Receipt
      </h6>
    </div>

    <!-- MODALS -->
    <receive-consignment-footer v-if="selectedReceive.length>0" :itemCount=selectedReceive.length :accessToken=accessToken></receive-consignment-footer>

  </div>
</template>
